import React from 'react'

import { NavLink } from 'react-router-dom'

import logo from '../logo1.jpg'


function Navbar() {
  return (
<nav className='navbar'>
    <div>
        <img src={logo} alt='bus-logo' className='logo'/>

    </div>
    <h1 class="font-handwritten">Briggs Flavours</h1>
    <div>
        <ul className='nav_menu'>
            <li><NavLink exact to='/' activeClassName="active">Home</NavLink></li>
            <li><NavLink to='/about' activeClassName="active">About</NavLink></li>
            <li><NavLink to='/food'activeClassName="active">Food</NavLink></li>
            <li><NavLink to='/travel'activeClassName="active">Travel</NavLink></li>
            <li><NavLink to='/blog' activeClassName="active">Blog</NavLink></li>
            <li><NavLink to='/contact' activeClassName="active">Contact</NavLink></li>
        </ul>
    </div>
</nav>

    )
}

export default Navbar